













import { AdgroupConfig, AdgroupFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { defineComponent, PropType, toRefs } from '@vue/composition-api';
import TtamTargetSummary from './index';

const name = 'ttam-target-summary-compose';
export default defineComponent({
  name,
  components: {
    TtamTargetSummaryContainer: TtamTargetSummary.TtamTargetSummaryContainer,
    TtamTargetSummaryItem: TtamTargetSummary.TtamTargetSummaryItem,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      required: true,
      default: () => ({}),
    },
  },
  setup(props) {
    const { campaignData, adgroupData, adgroupConfig } = toRefs(props);
    const { targetSummaryData } = TtamTargetSummary.usePropsTargetSummaryData({
      campaignData,
      adgroupData,
    });
    const { visible } = TtamTargetSummary.usePropsVisible({
      adgroupData,
      adgroupConfig,
    });
    return {
      name,
      targetSummaryData,
      visible,
    };
  },
});
